import styled from 'styled-components';

import Icon from './Icon';

interface IProps {
  text: string;
  startIcon?: string;
  endIcon?: string;
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;

  :hover {
    color: ${({ theme }) => theme.palette.text.link};
    font-weight: 600;
  }
`;

const TextWrapper = styled.div`
  text-wrap: nowrap;
`;

const iconWrapperStyle = {
  display: 'flex',
  alignItems: 'center',
};

const iconStyle = (startIcon = true, endIcon = false) => ({
  marginRight: startIcon ? '10px' : 0,
  marginLeft: endIcon ? '10px' : 0,
  width: 24,
  height: 24,
  fontSize: 'inherit',
});

const TextWithIcon = ({ text, startIcon, endIcon }: IProps) => {
  return (
    <Wrapper>
      {startIcon && (
        <Icon
          name={startIcon}
          style={iconStyle(Boolean(startIcon), Boolean(endIcon))}
          wrapperStyle={iconWrapperStyle}
        />
      )}

      <TextWrapper>{text}</TextWrapper>

      {endIcon && (
        <Icon
          name={endIcon}
          style={iconStyle(Boolean(startIcon), Boolean(endIcon))}
          wrapperStyle={iconWrapperStyle}
        />
      )}
    </Wrapper>
  );
};

export default TextWithIcon;
